import {useState} from "react";

// SAFE STORAGE GETTER / SETTER / REMOVER
// https://stackoverflow.com/a/76278779/13976355

// Define the storage mode, with fallback if localStorage not available
const backupStorage = {};
let storageMode = "localStorage";
try {
  // eslint-disable-next-line no-unused-expressions
  window.localStorage.length;
} catch (e) {
  try {
    // eslint-disable-next-line no-unused-expressions
    window.sessionStorage.length;
    storageMode = "sessionStorage";
  } catch (e) {
    storageMode = "backupStorage";
  }
}

export const safeLocalStorage = {
  getItem(key) {
    switch (storageMode) {
      case "localStorage":
        return localStorage.getItem(key);
      case "sessionStorage":
        return sessionStorage.getItem(key);
      case "backupStorage":
      default:
        return backupStorage[key];
    }
  },

  setItem(key, value) {
    switch (storageMode) {
      case "localStorage":
        return localStorage.setItem(key, value);
      case "sessionStorage":
        return sessionStorage.setItem(key, value);
      case "backupStorage":
      default:
        backupStorage[key] = value;
        return;
    }
  },

  removeItem(key) {
    switch (storageMode) {
      case "localStorage":
        return localStorage.removeItem(key);
      case "sessionStorage":
        return sessionStorage.removeItem(key);
      case "backupStorage":
      default:
        delete backupStorage[key];
        return;
    }
  },
};

// GET / SET / REMOVE UTILS

export const getLocalStorage = (key, defaultValue) => {
  try {
    // Get from local storage by key
    const item = safeLocalStorage.getItem(key);
    // Parse stored json or if none return initialValue
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    // If error also return initialValue
    console.error(error);
    return defaultValue;
  }
};

export const setLocalStorage = (key, value) => {
  try {
    // Save to local storage
    safeLocalStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // A more advanced implementation would handle the error case
    console.error(error);
  }
};

export const removeLocalStorage = (key) => {
  try {
    // Get from local storage by key
    safeLocalStorage.removeItem(key);
  } catch (error) {
    // If error also return initialValue
    console.error(error);
  }
};

export const useLocalStorageState = (key, defaultValue) => {
  const [value, setValue] = useState(getLocalStorage(key, defaultValue));

  const setLocalStorageValue = (val) => {
    setLocalStorage(key, val);
    setValue(val);
  };

  return [value, setLocalStorageValue];
};

export const createLocalStorageManager = (key, defaultValue) => {
  const manager = () => getLocalStorage(key, defaultValue);
  manager.set = (val) => setLocalStorage(key, val);
  manager.remove = () => removeLocalStorage(key);
  return manager;
};
